import { getSupabaseBrowserClient } from "@/lib/supabase/client";

export type PushPlatform = "ios" | "android";

export async function registerDevicePushToken(input: {
  platform: PushPlatform;
  token: string;
  appVersion?: string | null;
}) {
  const supabase = getSupabaseBrowserClient();
  const { data, error } = await supabase.rpc("register_device_push_token", {
    p_platform: input.platform,
    p_token: input.token,
    p_app_version: input.appVersion ?? null,
  });

  if (error) {
    throw error;
  }

  return data;
}

export async function unregisterDevicePushToken(input: {
  platform: PushPlatform;
  token: string;
}) {
  const supabase = getSupabaseBrowserClient();
  const { error } = await supabase.rpc("unregister_device_push_token", {
    p_platform: input.platform,
    p_token: input.token,
  });

  if (error) {
    throw error;
  }
}
